"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Table = _interopRequireDefault(require("./Table"));
var _TableTdInfo = _interopRequireDefault(require("./TableTdInfo"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
var VerticalTh = _styledComponents["default"].th.withConfig({
  displayName: "VerticalTable__VerticalTh",
  componentId: "ustw23-0"
})(["&&&{width:", ";vertical-align:", ";}"], function (props) {
  return props.styles.width;
}, function (props) {
  return props.styles.verticalAlign;
});
var VerticalTd = (0, _styledComponents["default"])(_TableTdInfo["default"]).withConfig({
  displayName: "VerticalTable__VerticalTd",
  componentId: "ustw23-1"
})(["&&&{background-color:", ";font-weight:", ";}"], function (props) {
  return props.styles.backgroundColor;
}, function (props) {
  return props.styles.fontWeight;
});
var HeaderTable = _styledComponents["default"].table.attrs(function () {
  return {
    className: "table table-sm",
    name: "best-table"
  };
}).withConfig({
  displayName: "VerticalTable__HeaderTable",
  componentId: "ustw23-2"
})(["&&&{margin:2px;padding-bottom:4px;}"]);
var HeaderTh = (0, _styledComponents["default"])(VerticalTh).attrs(function () {
  return {
    className: "BCR-Vertical-Header-Th"
  };
}).withConfig({
  displayName: "VerticalTable__HeaderTh",
  componentId: "ustw23-3"
})(["&&&{background-color:", ";color:", ";border:none;padding-bottom:0;font-size:11px;font-weight:300;}"], function (props) {
  return props.theme["light-grey"];
}, function (props) {
  return props.theme["dark-grey"];
});
/* helper functions */

var getCellValue = function getCellValue(obj, key, override, rowIndex, colIndex) {
  var value = obj[key];
  if (override === undefined || override === null) return value; // if its a function, call the override function

  if (typeof override === "function") return override(obj, rowIndex, colIndex); // if its a react element, just return

  if (_react["default"].isValidElement(override)) return override; // in any other case, just return the value

  return value;
};
var fillHeaderTable = function fillHeaderTable(headers, data) {
  if (!headers.length) return [];
  var headersToRender = _toConsumableArray(headers);
  var difference = data.length - headers.length + 1;
  for (var i = 0; i < difference; i++) {
    headersToRender.push({
      name: ""
    });
  }
  return headersToRender;
}; // component

var VerticalTable = function VerticalTable(_ref) {
  var rows = _ref.rows,
    headers = _ref.headers,
    data = _ref.data,
    className = _ref.className,
    styles = _ref.styles;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    th: {
      width: "150px",
      verticalAlign: "middle"
    },
    td: {
      backgroundColor: Theme["white"],
      fontWeight: "normal"
    }
  };
  var TableStyles = {
    th: _objectSpread({}, DefaultStyle.th, {}, styles.th),
    td: _objectSpread({}, DefaultStyle.td, {}, styles.td)
  };
  var headersToRender = fillHeaderTable(headers, data);
  return _react["default"].createElement("div", {
    className: "BCR-Vertical-Table ".concat(className || "").trim()
  }, !headers.length ? null : _react["default"].createElement(HeaderTable, null, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, headersToRender.map(function (header, hIndex) {
    return _react["default"].createElement(HeaderTh, {
      styles: TableStyles.th,
      key: hIndex
    }, header.name);
  })))), _react["default"].createElement(_Table["default"], null, _react["default"].createElement("tbody", null, rows.map(function (row, rowIndex) {
    return _react["default"].createElement("tr", {
      key: rowIndex
    }, _react["default"].createElement(VerticalTh, {
      styles: TableStyles.th,
      key: "".concat(rowIndex, "Th")
    }, row.name), data.map(function (obj, objIndex) {
      return _react["default"].createElement(VerticalTd, {
        styles: TableStyles.td,
        key: "".concat(rowIndex).concat(objIndex)
      }, getCellValue(obj, row.key, row.cellOverride, rowIndex, objIndex));
    }));
  }))));
};
VerticalTable.defaultProps = {
  styles: {
    td: {},
    th: {}
  },
  headers: [],
  className: ""
};
VerticalTable.propTypes = {
  /** rows for the vertical table */
  rows: _propTypes["default"].array.isRequired,
  /** data for the vertical table */
  data: _propTypes["default"].array.isRequired,
  /** headers for the vertical table */
  headers: _propTypes["default"].array,
  /** overrideable styles */
  styles: _propTypes["default"].shape({
    td: _propTypes["default"].shape({
      width: _propTypes["default"].string,
      verticalAlign: _propTypes["default"].string
    }),
    th: _propTypes["default"].shape({
      backgroundColor: _propTypes["default"].string,
      fontWeight: _propTypes["default"].string
    })
  }),
  className: _propTypes["default"].string
};
var _default = VerticalTable;
exports["default"] = _default;